import NutritionHistory from './NutritionHistory';

export default NutritionHistory;
